// @ts-nocheck
/* eslint-disable */
import * as registry from '../../registry.js'
/**
* @param {{  }} i
*/
export const attendingPrompt_noUpdatesInfo = (i) => `We only send information about this one event. Never spam.`